import { Button, Dropdown, Drawer, Input, Slider, Segmented, Select, Card, Collapse, Tooltip, Modal, Upload, message as antdMessage, InputNumber, Popconfirm, Switch, Tag, Checkbox, Empty } from "antd";
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { AlignLeftOutlined, PicCenterOutlined, InboxOutlined, DeleteOutlined, MenuOutlined, ColumnHeightOutlined, PictureOutlined, FieldTimeOutlined, CalendarOutlined, FontColorsOutlined, HomeOutlined, MailOutlined, NumberOutlined, PhoneOutlined, PlusOutlined, EditOutlined, ClockCircleOutlined, PlaySquareOutlined, FastForwardOutlined, WarningOutlined, RedoOutlined, ThunderboltOutlined } from '@ant-design/icons';

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { IoImageOutline } from "react-icons/io5";
import { FaStarHalfStroke } from "react-icons/fa6";
import "./main.css"
import {
    Position,
    Handle,
    useReactFlow,
    MarkerType
} from '@xyflow/react';
import UploadFileToS3 from '../../../../funcs/s3Upload'
import { v4 as uuidv4 } from 'uuid';
import { CustomHandle } from "../handler/main";
import DeleteNode from "../delete_node/main";

import { GiChoice } from "react-icons/gi";

import { fireDB } from "../../../../funcs/firebase";
import { doc, setDoc, getDoc, updateDoc, arrayUnion } from "firebase/firestore";

const { Dragger } = Upload;


const saveImageURL = async (userId, url) => {
    console.log("-=-=-=-=", userId, url)
    try {
        const docRef = doc(fireDB, 'users', userId, 'medias', "uploaded_media");
        //   await setDoc(docRef, [url] );
        await updateDoc(docRef, {
            urls: arrayUnion(url) // 'urls' is the field in Firestore storing the image list
        });

    } catch (error) {
        console.error("Error saving draft automation:", error);
    }
};



const handleProductImageUpload = async (files, product_id, messageApi) => {

    let media_urls = []
    for (const file of files) {
        let media_id = uuidv4();
        let media_type = file.name.split('.').pop();
        let url = await UploadFileToS3(messageApi, file.originFileObj, product_id, media_id, media_type);
        let user_detail = JSON.parse(localStorage.getItem("userData"))
        saveImageURL(user_detail.user_id, url)
        media_urls.push(url)
    }
    return media_urls
}



const RenderQuestionData = ({ messages ,  setShowSubConfig, setSelectedIndex, toggleDrawer }) => {

    const RenderTextMessage = ({ message , messageIndex ,  setShowSubConfig, setSelectedIndex, toggleDrawer }) => {

        if (message.question == "" || message.question == undefined) {
            return
        }
        return (
            <div onClick={toggleDrawer} className="render-text-reply" style={{ textAlign: 'right' }}>
                <p style={{minHeight:'10px', textAlign:"left", padding:"10px"}}>{message.question}</p>
                <div className="smart-replies" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    {message?.smartReplies?.map((smartReply, index) => (
                        <div
                            key={`${message.id}-${index}`}
                            style={{ position: 'relative', marginBottom: '10px', width: 'fit-content' }} // Added width: fit-content
                        >
                            <Button
                                color="primary"
                                variant="dashed"
                                style={{
                                    display: 'block',
                                    width: 'auto',
                                    alignSelf: 'flex-end',
                                    paddingRight: '8px',
                                    paddingLeft: '8px',
                                    borderRadius: '10px',
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textAlign: 'right',
                                    margin: 0,
                                }}
                            >
                                {smartReply}
                                {/* <CustomHandle
                                    id={`${message.id}-${index}`}
                                    type={'source'}
                                    onDelete={() => console.log('Delete edge action')}
                                /> */}
                            </Button>
                        </div>
                    ))}

                       {message?.skip_option?.enable &&
                        <div
                            key={`${message.id}-skip-option`}
                            style={{ position: 'relative', marginBottom: '10px', width: 'fit-content' }} // Added width: fit-content
                        >
                            <Button
                                color="primary"
                                variant="dashed"
                                style={{
                                    display: 'block',
                                    width: 'auto',
                                    alignSelf: 'flex-end',
                                    paddingRight: '8px',
                                    paddingLeft: '8px',
                                    borderRadius: '10px',
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textAlign: 'right',
                                    margin: 0,
                                }}
                            >
                                {message?.skip_option?.skip_text}
                            </Button>
                        </div>
                        }
                    
                    {/* <div>
                        <Button
                        className="follow-up-btn"
                            color="purple" variant="dashed"
                            style={{
                                display: 'block',
                                width: 'auto',
                                alignSelf: 'flex-end',
                                paddingRight: '10px',
                                paddingLeft: '10px',
                                borderRadius: '10px',
                                whiteSpace: 'normal',
                                wordWrap: 'break-word',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                textAlign: 'right',
                                margin: 0,
                                fontSize: "12px",
                                cursor: "pointer",
                                marginBottom:"10px"
                                
                            }}
                            onClick={() => {
                                toggleDrawer(true);setSelectedIndex(messageIndex); setShowSubConfig(true);
                            }}
                        icon={<ThunderboltOutlined style={{ fontSize: "10px", marginRight:"4px" }} />}
                        >
                            Action
                            <CustomHandle
                                id={`${message.id}-action`}
                                type={'source'}
                                onDelete={() => console.log('Delete edge action')}
                            />
                        </Button>
                    </div> */}

                    <div>
                      <Tooltip title="If user not responded to this question, send follow up message, Click to edit follow up duration. Connect the next steps.">
                        <Button
                        className="follow-up-btn"
                            color="purple" variant="filled"
                            style={{
                                display: 'block',
                                width: 'auto',
                                alignSelf: 'flex-end',
                                paddingRight: '10px',
                                paddingLeft: '10px',
                                borderRadius: '10px',
                                whiteSpace: 'normal',
                                wordWrap: 'break-word',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                textAlign: 'right',
                                margin: 0,
                                fontSize: "12px",
                                cursor: "pointer"
                                
                            }}
                            onClick={() => {
                                toggleDrawer(true);setSelectedIndex(messageIndex); setShowSubConfig(true);
                            }}
                        icon={<ClockCircleOutlined style={{ fontSize: "10px", marginRight:"4px" }} />}
                        >
                            {message?.follow_up_duration ? "Follow up after " : "Follow Up "} {message?.follow_up_duration} {message?.follow_up_duration_type == "m" ? "Min" :message?.follow_up_duration_type =="h" ? "Hrs" : message?.follow_up_duration_type == "s" ? "Sec" : ""}
                            <CustomHandle
                                id={`${message.id}-followup`}
                                type={'source'}
                                onDelete={() => console.log('Delete edge action')}
                            />
                        </Button>
                        </Tooltip>
                    </div>
                </div>
            </div>
        )
    }


    const RenderDelayTime = (message) => {


        message = message.message

        return (
            <div onClick={toggleDrawer} className="render-delay">

                <div className="delay-header">
                {/* 💤 Delay */}
                    <FieldTimeOutlined style={{ fontSize: "14px", color: "#0800ff" }} /> Delay
                </div>
                <p style={{ fontSize: "6px", margin: 0, color: "rgba(0, 0, 0, 0.316)" }}>Below messages will be delayed for</p>
                <div className="delay-core">
                    {message.delayDuration} {message.durationType == "m" ? "Min" : "Sec"}
                </div>
            </div>
        )

    }
    return (

        <div style={{ marginTop: "10px" }}>
            {
                messages?.map((message, index) => {
                    // if (message?.question_type === "button") {
                    //     return <RenderButtonTemplate key={index} templateMessages={message} />;
                    // } 
                    if (message?.question_type != undefined) {
                        return <RenderTextMessage messageIndex = {index} key={index} message={message}  setShowSubConfig = {setShowSubConfig} setSelectedIndex = {setSelectedIndex} toggleDrawer={toggleDrawer}/>;
                    } 
                    if (message?.type === "delay") {
                        return <RenderDelayTime key={index} message={message} />;
                    }
                    return null; // Ensures the map function always returns something
                })
            }
        </div>
    )

}

const SubMessageConf = React.memo(({ message, index, onmessageChange, mediaURLS, setMediaURLS, setShowSubConfig }) => {

    const [wrongInput, setWrongInput] = useState(message?.wrong_input || {})
    const [skipQuestion, setSkipQuestion] = useState(message?.skip_option || {})
    const [retryAttempt, setRetryAttempt] = useState(message?.retry_attempt || {})
    const [variable, setVariable] = useState(message?.custom_variable_name || "")

    const [followUpDuration, setFollowUpDuration] = useState(message?.follow_up_duration || 30);
    const [followUpDurationType, setFollowUpDurationType] = useState(message?.follow_up_duration_type || "m");


    useEffect(() => {
        onmessageChange({ ...message, skip_option: skipQuestion, retry_attempt: retryAttempt, wrong_input: wrongInput, custom_variable_name: variable ,
            follow_up_duration: followUpDuration, follow_up_duration_type: followUpDurationType
        });
    }, [wrongInput, skipQuestion, retryAttempt, variable,followUpDuration, followUpDurationType]);


    return (
        <div>

            <Card className="sub-msg-conf-card">
                <h3 > <FastForwardOutlined style={{color:"blue"}}/> Skip Question</h3>
                <Checkbox onChange={(e) => setSkipQuestion({ ...skipQuestion, enable: e.target.checked })} checked={skipQuestion?.enable} >
                    Let contact skip this question
                </Checkbox>
                {skipQuestion.enable &&
                    <>
                        <h4>Skip Button Text</h4>
                        <Input onChange={(e) => setSkipQuestion({ ...skipQuestion, skip_text: e.target.value })} value={skipQuestion.skip_text} />
                    </>
                }
            </Card>

            <Card className="sub-msg-conf-card">
                <h3 > <ClockCircleOutlined style={{color:"purple"}}/> Follow Up</h3>
                
                <p>If user not resoponded to this question, send follow up message.</p>
                
                
                <>
                    <h4>Follow up after</h4>

                    <div style={{ display: "flex", width:"100%", flexDirection: "row", gap: "10px" }}>
                            <InputNumber value={followUpDuration} onChange={(value) => { setFollowUpDuration(value) }} />
                            <Select style={{flex:"1"}} defaultValue={followUpDurationType} onChange={(value) => { setFollowUpDurationType(value); }} options={[{ "label": "Seconds", "value": "s" }, { "label": "Minutes", "value": "m" },{ "label": "Hour", "value": "h" }]} />
                    </div>
                </>
                
                <p style={{ color:"rgba(0,0,0,.4)"}}>Note : Maximum allowed is 24 hours, set 0 for no follow up.</p>
            </Card>

            <Card className="sub-msg-conf-card">
                <h3 > <WarningOutlined style={{color:"red"}}/> Invalid Response</h3>
                <p>This message will be sent when your contact send invalid response.</p>
                <Input.TextArea value={wrongInput?.message} onChange={(e) => setWrongInput({ ...wrongInput, message: e.target.value })} />
            </Card>


            <Card className="sub-msg-conf-card">
                <h3 > <RedoOutlined style={{color:"orange"}} /> Retry on Invalid Response</h3>
                <p>No of retry attempts if the contact gives invalid response</p>
                <Select
                    style={{ width: "300px" }}
                    onChange={(value) => setRetryAttempt({ ...retryAttempt, count: value })}
                    value={retryAttempt?.count == undefined ? 3 : retryAttempt?.count}
                    options={[
                        {
                            "value": 0,
                            "label": "No retry",
                        },
                        {
                            "value": 1,
                            "label": 1,
                        },
                        {
                            "value": 2,
                            "label": 2,
                        },
                        {
                            "value": 3,
                            "label": 3,
                        },
                        {
                            "value": 4,
                            "label": 4,
                        },
                        {
                            "value": 5,
                            "label": 5,
                        },
                        {
                            "value": -1,
                            "label": "Unitl its valid",
                        },
                    ]}
                >

                </Select>
            </Card>

            <Card className="sub-msg-conf-card">
                <h3>Variable Name <Tag color="purple">Advanced Option</Tag></h3>
                <p>Pick a cutom variable name</p>

                <Input value={variable} onChange={(e) => setVariable(e.target.value)} placeholder="please choose new variable name" />
            </Card>

        </div>
    )

})


const MessageType = React.memo(({ message, index, onmessageChange, mediaURLS, setMediaURLS, setShowSubConfig, setSelectedIndex }) => {
    const [messageApi, contextHolder] = antdMessage.useMessage();
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const onMediaUploadChange = ({ fileList }) => {
        let current_automation_id = localStorage.getItem("current_automation_id")
        handleProductImageUpload(fileList, current_automation_id, messageApi).then((local_mediaUrls) => {
            setMediaURLS([...local_mediaUrls, ...mediaURLS])
            setUploadedFiles(fileList.map((file) => file.uid))
        })
    }


    const [replyType, setReplyType] = useState(message?.type || "text");
    const [smartReplies, setSmartReplies] = useState(message?.smartReplies || []);
    const [templates, setTemplates] = useState(message?.templates || []);
    const [inputText, setInputText] = useState(message.text || "")

    const [showMediaModel, setShowMediaModel] = useState(false)

    const [selectedTemplate, setSelectedTemplate] = useState()

    const [question, setQuestion] = useState(message?.question || "")

    useEffect(() => {
        onmessageChange({ ...message, type: replyType, smartReplies, templates, text: inputText, question });
    }, [replyType, smartReplies, templates, message, inputText,question]);

    const addSmartReply = useCallback(() => {
        setSmartReplies((prevReplies) => [...prevReplies, ""]);
    }, []);

    const updateSmartReply = useCallback((index, value) => {
        setSmartReplies((prevReplies) => prevReplies.map((reply, i) => (i === index ? value : reply)));
    }, []);

    const removeSmartReply = useCallback((index) => {
        setSmartReplies((prevReplies) => prevReplies.filter((_, i) => i !== index));
    }, []);

    const addTemplate = useCallback(() => {
        if (templates.length < 10) {
            setTemplates((prevTemplates) => [...prevTemplates, { title: "", description: "", buttons: [], id: uuidv4() }]);
        }
    }, [templates]);

    const removeTemplate = useCallback((index) => {
        setTemplates((prevTemplates) => prevTemplates.filter((_, i) => i !== index));
    }, []);

    const updateTemplateField = useCallback((index, field, value) => {
        setTemplates((prevTemplates) => prevTemplates.map((template, i) => (i === index ? { ...template, [field]: value } : template)));
    }, []);

    const addButton = useCallback((templateIndex) => {
        setTemplates((prevTemplates) =>
            prevTemplates.map((template, i) =>
                i === templateIndex && template.buttons.length < 5
                    ? { ...template, buttons: [...template.buttons, { title: "", type: "postback", url: "" }] }
                    : template
            )
        );
    }, []);

    const removeButton = useCallback((templateIndex, buttonIndex) => {
        setTemplates((prevTemplates) =>
            prevTemplates.map((template, i) =>
                i === templateIndex ? { ...template, buttons: template.buttons.filter((_, j) => j !== buttonIndex) } : template
            )
        );
    }, []);

    const updateButtonField = useCallback((templateIndex, buttonIndex, field, value) => {
        setTemplates((prevTemplates) =>
            prevTemplates.map((template, i) =>
                i === templateIndex
                    ? {
                        ...template,
                        buttons: template.buttons.map((button, j) => (j === buttonIndex ? { ...button, [field]: value } : button)),
                    }
                    : template
            )
        );
    }, []);

    return (
        <div className="message-type">

            {!message?.question_type && <Segmented
                size="middle"
                value={replyType}
                shape="round"
                style={{ marginBottom: "10px" }}
                onChange={(value) => setReplyType(value)}
                options={[
                    { value: "text", icon: <AlignLeftOutlined />, "label": "Text" },
                    { value: "button", icon: <PicCenterOutlined />, "label": "Button" },
                ]}
            />

            }

            {(replyType === "text" && !message?.question_type) &&
                <div>
                    <Input.TextArea onChange={(e) => { setInputText(e.target.value) }} placeholder="Add your text or link you want to share" />

                    {/* Smart Replies Section */}
                    <div className="smart-reply" style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-end" }}>
                        {smartReplies.map((reply, index) => (
                            <div key={index} className="smart-reply-item" style={{ display: "flex", gap: "8px", marginTop: "8px", justifyContent: "flex-end" }}>
                                <Button
                                    className="smart-reply-delete"
                                    type="text"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => removeSmartReply(index)}
                                />
                                <Input
                                    value={reply}
                                    onChange={(e) => updateSmartReply(index, e.target.value)}
                                    placeholder="Enter smart reply"
                                    style={{ flex: 1, borderRadius: "20px", maxWidth: '260px' }}
                                />

                            </div>
                        ))}

                        <Button
                            color="primary"
                            variant="dashed"
                            icon={<PlusOutlined />}
                            onClick={addSmartReply}
                            style={{ marginTop: "8px", borderRadius: "20px", width: "180px" }}
                        >
                            Add Smart Reply
                        </Button>
                    </div>
                </div>

            }

            {(replyType === "button" && !message?.question_type) &&
                <div className="btn-msg">
                    {/* Button Templates Section */}
                    <div className="templates-container" style={{ display: "flex", gap: "10px", overflowX: "auto", paddingBottom: "10px" , paddingBottom: "20px" , scrollbarWidth:"inital !important"}}>
                        {templates.map((template, templateIndex) => (
                            <Card
                                key={templateIndex}
                                style={{ width: "280px", minWidth: "280px" }}
                                className="message-core-card"
                            >

                                {template.thumb_url == undefined && <IoImageOutline onClick={() => {
                                    setSelectedTemplate(templateIndex)
                                    setShowMediaModel(true)
                                }} style={{ display: "flex", width: "100%", marginBottom: "10px", fontWeight: "500", color: "#80808087", fontSize: "44px" }} />

                                }

                                {template.thumb_url != undefined && <img onClick={() => {
                                    setSelectedTemplate(templateIndex)
                                    setShowMediaModel(true)
                                }} className="template-thumb-image" src={template.thumb_url} />

                                }
                                <Input
                                    placeholder="Message title"
                                    value={template.title}
                                    style={{ marginBottom: "10px" }}
                                    onChange={(e) => updateTemplateField(templateIndex, "title", e.target.value)}
                                />
                                <Input.TextArea
                                    placeholder="Message Description"
                                    value={template.description}
                                    onChange={(e) => updateTemplateField(templateIndex, "description", e.target.value)}

                                />

                                {/* Buttons Section */}
                                <div style={{ marginTop: "10px" }}>
                                    <Collapse accordion style={{ marginTop: "10px" }}>
                                        {template.buttons.map((button, buttonIndex) => (
                                            <Collapse.Panel
                                                key={buttonIndex}
                                                header={button.title || "New Button"}
                                                extra={
                                                    <Button
                                                        type="text"
                                                        danger
                                                        icon={<DeleteOutlined />}
                                                        onClick={() => removeButton(templateIndex, buttonIndex)}
                                                    />
                                                }
                                            >
                                                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                                    <Input
                                                        placeholder="Button Name"
                                                        value={button.title}
                                                        onChange={(e) => updateButtonField(templateIndex, buttonIndex, "title", e.target.value)}
                                                    />
                                                    <Select
                                                        value={button.type}
                                                        onChange={(value) => updateButtonField(templateIndex, buttonIndex, "type", value)}
                                                        options={[
                                                            { value: "postback", label: "Regular" },
                                                            { value: "web_url", label: "URL" },
                                                        ]}
                                                        style={{ width: "100%" }}
                                                    />
                                                    {button.type === "web_url" && (
                                                        <Input
                                                            placeholder="URL"
                                                            value={button.url}
                                                            onChange={(e) => updateButtonField(templateIndex, buttonIndex, "url", e.target.value)}
                                                        />
                                                    )}
                                                </div>
                                            </Collapse.Panel>
                                        ))}
                                    </Collapse>


                                    {template.buttons.length < 5 && (
                                        <Button
                                            type="dashed"
                                            icon={<PlusOutlined />}
                                            onClick={() => addButton(templateIndex)}
                                            style={{ marginTop: "8px" }}
                                        >
                                            Add Button
                                        </Button>
                                    )}

                                </div>

                                <Tooltip title="Delete This template">
                                    <Button className="delete-message-card" type="text" danger icon={<DeleteOutlined />} onClick={() => removeTemplate(templateIndex)} />
                                </Tooltip>
                            </Card>
                        ))}

                        {templates.length < 10 && (
                            <Button type="dashed" icon={<PlusOutlined />} onClick={addTemplate}>
                                Add Template
                            </Button>
                        )}
                    </div>

                </div>
            }

            {
                message?.question_type &&
                <Card>

                    <Input.TextArea
                        style={{ flex: 1, borderRadius: "6px", maxWidth: '260px', height: "auto" }}
                        placeholder="Enter the question"
                        value={question}
                        onChange={ (e) => setQuestion(e.target.value) }
                    />

                    <div className="smart-reply" style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-end" }}>

                        {smartReplies.map((reply, index) => (
                            <div key={index} className="smart-reply-item" style={{ display: "flex", gap: "8px", marginTop: "8px", justifyContent: "flex-end" }}>
                                <Button
                                    className="smart-reply-delete"
                                    type="text"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => removeSmartReply(index)}
                                />
                                <Input
                                    value={reply}
                                    onChange={(e) => updateSmartReply(index, e.target.value)}
                                    placeholder="Enter smart reply"
                                    style={{ flex: 1, borderRadius: "20px", maxWidth: '260px' }}
                                />

                            </div>
                        ))}

                        {["bool", "rating"].includes(message?.question_type) && <Button
                            color="primary"
                            variant="dashed"
                            icon={<PlusOutlined />}
                            onClick={addSmartReply}
                            style={{ marginTop: "8px", borderRadius: "20px", width: "180px" }}
                        >
                            Add More Option
                        </Button>}

                        {message?.skip_option?.enable ?

                            <Button
                                color="primary"
                                variant="dashed"
                                onClick={() => { setSelectedIndex(index); setShowSubConfig(true) }}

                                style={{ marginTop: "8px", borderRadius: "20px", width: "180px" }}
                            >
                                {message?.skip_option?.skip_text}
                                <EditOutlined />
                            </Button>

                            :

                            <Button color="default" variant="dashed"
                                onClick={() => { setSelectedIndex(index); setShowSubConfig(true) }}
                                style={{ marginTop: "8px", borderRadius: "20px", width: "200px" }}
                            >
                                Make this question skippable
                            </Button>

                            }
                            
                            
                        
                    </div>

                    <Button block color="primary" onClick={() => { setSelectedIndex(index); setShowSubConfig(true) }} variant="dashed" style={{ marginTop: "20px" }}>
                        Contact Reply : {message?.question_type} <EditOutlined />
                    </Button>
                    <Button className="follow-up-btn" onClick={() => { setSelectedIndex(index); setShowSubConfig(true) }} style={{ marginTop: "8px" }} color="purple" variant="dashed" icon={<ClockCircleOutlined/>} block>
                        {message?.follow_up_duration ? "Follow up after " : "Follow Up "} {message?.follow_up_duration} {message?.follow_up_duration_type == "m" ? "Min" :message?.follow_up_duration_type == "h" ? "Hrs" : message?.follow_up_duration_type == "s" ? "Sec" : ""}
                    </Button>

                </Card>

            }


            <Modal onOk={() => { setShowMediaModel(false) }} 
            // confirmLoading = {savingtoLive}
            onCancel={() => { setShowMediaModel(false) }} onClose={() => { setShowMediaModel(false) }} title="Select Media" open={showMediaModel}>
                {contextHolder}
                <Dragger
                    multiple
                    beforeUpload={() => { return false }}
                    accept='image/png, image/jpeg'
                    onChange={onMediaUploadChange}
                    fileList={[]}
                >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag Images to this area to upload</p>


                </Dragger>
                <div className="uploaded-images">
                    {
                        mediaURLS.map((media) => <img onClick={() => {
                            let temp_templates = [...templates]
                            temp_templates[selectedTemplate].thumb_url = media
                            setTemplates([...temp_templates])
                        }} src={media} />)
                    }
                </div>
            </Modal>
        </div>
    );
})



export default function QuestionNode({ id, data }) {

    const { updateNodeData } = useReactFlow();
    const [messages, setMessages] = useState(data?.messages)

    const [mediaURLS, setMediaURLS] = useState([])

    const [showSubConfig, setShowSubConfig] = useState(false)

    const [selectedIndex, setSelectedIndex] = useState(-1)

    useEffect(() => {
        const fetchMediaURLs = async () => {
            let user_detail = JSON.parse(localStorage.getItem("userData"))
            if (!user_detail.user_id) return;

            try {
                const docRef = doc(fireDB, "users", user_detail.user_id, "medias", "uploaded_media");
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setMediaURLS(data.urls || []); // Set state with URLs (or empty array)
                } else {
                    console.log("No uploaded media found.");
                }
            } catch (error) {
                console.error("Error fetching media URLs:", error);
            }
        };
        fetchMediaURLs();
    }, []);

    useEffect(() => {
        setMessages(data?.messages)
    }, [data])
    const toggleDrawer = () => {
        let toogle = data?.toogleDrawer == undefined ? false : data?.toogleDrawer
        updateNodeData(id, { ...data, toogleDrawer: !toogle, messages: messages })
    };

    const toggleSubDrawer = () => {

        // setShowSubConfig(-1)
        setSelectedIndex(-1)
        // updateNodeData(id, { ...data, showSubConfig: !toogle, messages: messages })
    };

    const addMessage = ({ addType }) => {

        let new_messages = { id: Date.now(), "question_type": addType }
        let helper_text = {
            "name": {
                "text": "Before we proceed, please share your full name.",
                "wrong_input": "Oops! That doesn't seem like a valid name. Here’s an example: Vin Diesel."
            },
            "phone": {
                "text": "Please provide your WhatsApp phone number for further communication.",
                "wrong_input": "Oops! That doesn't seem like a valid phone number. Example: +919876543210."
            },
            "email": {
                "text": "Kindly share your email address so we can send you confirmation details.",
                "wrong_input": "Oops! That doesn't seem like a valid email. Example: me@mail.com."
            },
            "address": {
                "text": "Please enter your full address, including street details and postal code.",
                "wrong_input": "Oops! That address seems incomplete. Example: No. 34/1, Street Name, City, State, Country, Postal Code."
            },
            "bool": {
                "text": "Were you satisfied with our service?",
                "wrong_input": "Please select an option from the choices provided.",
                "choice": ["Yes", "No"]
            },
            "number": {
                "text": "Please enter a number (e.g., your age or shoe size).",
                "wrong_input": "Oops! That doesn't seem like a valid number. Example: 10."
            },
            "date": {
                "text": "Please enter your date of birth.",
                "wrong_input": "Oops! That doesn't seem like a valid date. Please use this format: May 16, 1999."
            },
            "rating": {
                "text": "How would you rate our service?",
                "wrong_input": "Please select a rating from 1 (poor) to 5 (excellent).",
                "choice": ["⭐⭐⭐⭐⭐", "⭐⭐⭐⭐", "⭐⭐⭐", "⭐⭐", "⭐"]
            }
        }
        
        if (addType == "delay") {
            new_messages["type"] = addType
            new_messages["delayDuration"] = 2
            new_messages["durationType"] = "m"
        }
        else {
            let question_data = {
                skip_option: {
                    enable: false,
                    skip_text: "Skip"
                },
                retry_attempt: {
                    count: 3,
                },
                wrong_input: {
                    message: helper_text?.[addType]?.wrong_input,
                },
                smartReplies: helper_text?.[addType]?.choice || [],
                custom_variable_name: ""
            }
            new_messages = { ...new_messages, ...question_data, question: helper_text?.[addType]?.text, }
        }
        setMessages()
        if (data.messages != undefined) {
            updateNodeData(id, { ...data, messages: [...data.messages, new_messages] })
            setMessages([...data.messages, new_messages])
        }
        else {
            updateNodeData(id, { ...data, messages: [new_messages] })
            setMessages([new_messages])
        }
    }

    // Remove a message
    const removeMessage = (id_) => {
        let non_del_msg = [...data.messages.filter((msg) => msg.id !== id_)]
        if (non_del_msg.length < 1) {
            updateNodeData(id, { ...data, messages: [] })
            setMessages([])
        }
        else {
            updateNodeData(id, { ...data, messages: [...non_del_msg] })
            setMessages(non_del_msg)
        }

    };

    // Handle Drag & Drop
    const onDragEnd = (result) => {
        if (!result.destination) return;

        const updatedMessages = Array.from(data.messages);
        const [movedItem] = updatedMessages.splice(result.source.index, 1);
        updatedMessages.splice(result.destination.index, 0, movedItem);
        console.log("-=-=-=-=-= drag end", updatedMessages)
        updateNodeData(id, { ...data, messages: [...updatedMessages] })
        setMessages([...updatedMessages])
    };

    let pstyle = { margin: 0, marginTop: "4px" }
    const items = [
        {
            key: '1',
            type: 'group',
            label: 'Questions',
            children: [
                {
                    key: "name",
                    icon: <FontColorsOutlined />,
                    label: "Name",
                },
                {
                    key: "phone",
                    icon: < PhoneOutlined />,
                    label: "Phone",
                },
                {
                    key: "email",
                    icon: <MailOutlined />,
                    label: "Email",
                },
                {
                    key: "text",
                    icon: <AlignLeftOutlined />,
                    label: "Text",
                },
                {
                    key: "address",
                    icon: <HomeOutlined />,
                    label: "Address",
                },
                {
                    key: "bool",
                    icon: <GiChoice />,
                    label: "Yes or No",
                },
                {
                    key: "number",
                    icon: <NumberOutlined />,
                    label: "Number",
                },
                {
                    key: "date",
                    icon: <CalendarOutlined />,
                    label: "Date",
                },
                {
                    key: "rating",
                    icon: <FaStarHalfStroke />,
                    label: "Rating",
                },
            ],
        },
        // {
        //     key: '2',
        //     type: 'group',
        //     label: 'Others',
        //     children: [
        //         {
        //             key: '3',

        //             label: 'Message',
        //         },
        //         {
        //             key: '4',

        //             label: 'Delay',
        //         },
        //         {
        //             key: '5',

        //             label: 'Follow ups',
        //         },
        //     ]

        // },


    ];

    return (

        <div className="flow-comp">

            

            <CustomHandle type="target" id={`${id}`} />

            <div className="comp-header">
            <DeleteNode editNode={toggleDrawer} updateNodeData={updateNodeData} id={id} data={data} />

            <p className="comp-title" onClick={toggleDrawer}>Question & Answers</p>
            </div>
            {(messages || []).length < 1 &&
            
            <Empty
            
                description={
                <h6>
                    Looks Empty, Add a question
                </h6>
                }
            >
                <Button type="primary" onClick={toggleDrawer}>Add Question</Button>
            </Empty>
                        
            }
            {messages != undefined && <RenderQuestionData toggleDrawer={toggleDrawer} messages={messages || []}  setShowSubConfig = {setShowSubConfig} setSelectedIndex = { setSelectedIndex }  />}
            
            <Drawer
                width={"400px"}
                style={{ backgroundColor: '#f5f5ff' }}
                //open={openDrawer}
                placement="left"
                open={data?.toogleDrawer}
                onClose={toggleDrawer}
                // onClose={() => {setOpenDrawer(false)}}
                title="Manage Questions"
            >

                {data?.messages && data?.messages.length >= 1 && <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="messages-list">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                {data?.messages?.map((message, index) => (
                                    <Draggable key={message.id} draggableId={message.id.toString()} index={index}>
                                        {(provided) => (
                                            <div
                                                className="message-reply-card question-reply-card"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                style={{

                                                    ...provided.draggableProps.style
                                                }}
                                            >
                                                {/* Drag Handle */}
                                                <span
                                                    {...provided.dragHandleProps}
                                                    className="handler"
                                                >
                                                    <ColumnHeightOutlined />
                                                </span>

                                                <div style={{ flex: 1, overflowX: "scroll" }}>
                                                    
                                                    {
                                                        message.type != "delay" && <MessageType
                                                            message={message}
                                                            index={index}
                                                            mediaURLS={mediaURLS}
                                                            setMediaURLS={setMediaURLS}
                                                            setSelectedIndex={setSelectedIndex}
                                                            setShowSubConfig={setShowSubConfig}
                                                            onmessageChange={(updatedMessage) => {

                                                                let temp_data = { ...data }
                                                                temp_data["messages"][index] = updatedMessage
                                                                setMessages([...temp_data["messages"]])
                                                            }}
                                                        />
                                                    }
                                                </div>

                                                <Button
                                                    className="delete-message-reply"
                                                    type="text"
                                                    danger
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => removeMessage(message.id)}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                }

                <Dropdown.Button
                    color="primary"
                    type="primary"
                    icon={<PlusOutlined />}
                    placement="bottomLeft"

                    //  onClick={(e) => console.log("Selected key:", e.key)}
                    menu={{
                        items: items,
                        onClick: (e) =>
                            addMessage({ addType: e.key })

                    }}


                >
                    Add more questions


                    {/* <Button type="dashed" icon={<PlusOutlined />} onClick={(data_) => console.log("data-=",data_)}  style={{ width: "100%", marginTop: "10px" }}>
        Add Another Question
    </Button> */}
                </Dropdown.Button>

                {/* <Button type="dashed" icon={<PlusOutlined />} onClick={() => addMessage({ addType: "delay" })} style={{ width: "100%", marginTop: "10px" }}>
        Add Message Reply
    </Button>
    <Button type="dashed" icon={<PlusOutlined />} onClick={() => addMessage({ addType: "delay" })} style={{ width: "100%", marginTop: "10px" }}>
        Add Delay
    </Button> */}

                <Drawer

                    width={"400px"}
                    style={{ backgroundColor: '#f5f5ff' }}
                    placement="left"
                    open={selectedIndex >= 0 ? true : false}
                    onClose={toggleSubDrawer}
                    title="Question Configuration"
                >

                    {(selectedIndex != -1 && data?.messages && data?.messages.length >= 1) && <SubMessageConf
                        message={data?.messages[selectedIndex]}
                        // index={selectedIndex}
                        mediaURLS={mediaURLS}
                        setMediaURLS={setMediaURLS}
                        setShowSubConfig={setShowSubConfig}
                        onmessageChange={(updatedMessage) => {

                            let temp_data = { ...data }
                            temp_data["messages"][selectedIndex] = updatedMessage
                            setMessages([...temp_data["messages"]])
                        }}
                    />
                    }
                </Drawer>

            </Drawer>

                <Button color="default" variant="solid"
                block
                    style={{
                        marginBottom:"0",    
                        marginTop:"20px"                              
                    }}>
                    Next Step {<CustomHandle type="source" id={`${id}`} />}
                </Button>
                
            {/* <CustomHandle type="source" id={`${id}`} /> */}
        </div>
    )

}